const onClick = (e) => {

	if( e.target && e.target.matches('a.external') && e.which !== 2 ){
		window.open(e.target.href);
		e.preventDefault();
	}

};

document.addEventListener('click', onClick);



// WEBPACK FOOTER //
// ./src/js/modules/links.js